import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import { VIcon, VBtn, VSnackbar } from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VIcon,
    VBtn,
  }
})

export default new Vuetify({
  icons: {
    iconfont: 'md'
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#0a6c86',       // azul oceandrivers profundo
        secondary: '#2dc6d6',     // azul petróleo / soporte
        accent: '#00ffff',        // turquesa principal marca
        info: '#1aa7d1',          // azul brillante
        success: '#22c55e',
        warning: '#f4b400',
        error: '#e65054',

        background: '#f6fbfd',
        surface: '#ffffff',

        base03: '#00334c',
        base02: '#0f4c5c',
        base01: '#d9f4f8',

        grey: '#6b7c86',
        light_grey: '#e8f1f4',

        blue_1: '#00334c',
        blue_2: '#0a6c86',
        blue_3: '#149ec2',
        blue_4: '#2dc6d6',
        blue_5: '#7fe3ee',
        blue_6: '#dff8fb',

        sail_white: '#ffffff',
        sail_line: '#b9ecf2',
        glow: '#6fe7f2',
        highlight: '#27d3c3',
        yellow: '#f4b400'
      },

      dark: {
        primary: '#2dc6d6',
        secondary: '#149ec2',
        accent: '#00ffff',
        info: '#38bdf8',
        success: '#22c55e',
        warning: '#f4b400',
        error: '#ff6b6b',

        background: '#071b24',
        surface: '#0c2530',

        base03: '#021018',
        base02: '#0c2530',
        base01: '#dff8fb',

        grey: '#9fb3bb',
        light_grey: '#1c3640',

        blue_1: '#071b24',
        blue_2: '#0c2530',
        blue_3: '#0a6c86',
        blue_4: '#149ec2',
        blue_5: '#2dc6d6',
        blue_6: '#7fe3ee',

        sail_white: '#f5feff',
        sail_line: '#8edee8',
        glow: '#2dc6d6',
        highlight: '#7fe3ee',
        yellow: '#ffd166'
      }
    }
  }
})